import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function LatestVideos() {
  const latestVideos = videos
    .filter((v) => !v.featured)
    .sort((a, b) => new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime())
    .slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新上线
            </h2>
            <p className="text-sm text-foreground-600">第一时间追更，不错过每一部好剧</p>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button
              type="button"
              className="w-8 h-8 rounded-full bg-background-100 hover:bg-background-200 flex items-center justify-center transition-colors duration-200 cursor-pointer"
              aria-label="上一个"
            >
              <i className="ri-arrow-left-s-line text-foreground-600"></i>
            </button>
            <button
              type="button"
              className="w-8 h-8 rounded-full bg-background-100 hover:bg-background-200 flex items-center justify-center transition-colors duration-200 cursor-pointer"
              aria-label="下一个"
            >
              <i className="ri-arrow-right-s-line text-foreground-600"></i>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {latestVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute bottom-2 right-2 px-2 py-1 rounded-md bg-black/70 text-background-50 text-xs">
                  {video.duration}
                </div>
                <div className="absolute top-2 right-2 px-2 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
                  新
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {video.title}
                </h3>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500 bg-background-200 px-2 py-1 rounded-md">
                    {video.platform}
                  </span>
                  <span className="text-xs text-foreground-500">{video.releaseDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}